/**
 * API client functions for Microsoft 365 integration endpoints.
 */

import type * as API from "../api-types";
import { apiClient } from "./client";

export function startOAuthFlow(
  redirectUri?: string,
): Promise<API.StartOAuthFlowResponse> {
  return apiClient.post<API.StartOAuthFlowResponse>(
    "m365/actions/start-m365-oauth-flow",
    { redirect_uri: redirectUri },
  );
}

export function disconnect(
  appUserId?: string,
): Promise<API.DisconnectResponse> {
  return apiClient.post<API.DisconnectResponse>(
    "m365/actions/disconnect-m365-account",
    { app_user_id: appUserId },
  );
}

export function getConnectionHealth(): Promise<API.ConnectionHealthResponse[]> {
  return apiClient.get<API.ConnectionHealthResponse[]>(
    "m365/connection/health",
  );
}
